import axios from 'axios';

const ROOT = 'api/v1';

const LogOperationHistoryApi = {
  getLogOperationHistoryParticipants(statusHistoryId) {
    return axios.get(`${ROOT}/logs/operations/statuses/${statusHistoryId}/participants`);
  }
};

export default LogOperationHistoryApi;
